import { SearchSource } from '@carvana/merch-contracts';
import { useContext } from 'react';
import {
  mapSuggestedFiltersToChipItems,
  type SuggestedFilterChipItem
} from '@/common/SuggestedFilterChips';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import SuggestedFiltersContext from '~/context/srp/SuggestedFiltersContext';
import type { SuggestedFilter } from '~/contracts/common';
import {
  useIsSuggestedFiltersLoaded,
  useShowSuggestedFilters
} from '~/hooks/srp/selectors/useSuggestedFilters';
import useIsInSuggestedFilterCountsExperiment from '~/hooks/srp/useIsInSuggestedFilterCountsExperiment';
import useIsInSuggestedFilters2RowExperiment from '~/hooks/srp/useIsInSuggestedFilters2RowExperiment';

type ReturnType = {
  isLoading: boolean;
  items: Array<SuggestedFilterChipItem>;
  show2RowSuggestedFilters: boolean;
  showCounts: boolean;
  showSuggestedFilters: boolean;
};

export default function useSuggestedFilterChipItems(): ReturnType {
  const { setAppliedFilters } = useContext(AppliedFiltersContext);
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { suggestedFilters, suggestedFiltersRequestId } = useContext(
    SuggestedFiltersContext
  );
  const isInSuggestedFilterCountsExperiment =
    useIsInSuggestedFilterCountsExperiment();
  const isInSuggestedFilters2RowExperiment =
    useIsInSuggestedFilters2RowExperiment();
  const isSuggestedFiltersLoaded = useIsSuggestedFiltersLoaded();
  const showComposerTreatment = useShowComposerTreatment();
  const showSuggestedFilters = useShowSuggestedFilters();
  const trackEvent = useTrackEvent();

  const handleSuggestedFilterClick = (suggestedFilter: SuggestedFilter) => {
    setSearchSource(SearchSource.SuggestedFilter);
    setAppliedFilters(suggestedFilter.searchFilters);

    trackEvent('Suggested filters', {
      action: 'clicked',
      source: showComposerTreatment ? 'composer' : 'page',
      suggestedFilter,
      suggestedFiltersRequestId
    });
  };

  const items = mapSuggestedFiltersToChipItems(
    suggestedFilters.data,
    handleSuggestedFilterClick
  );

  return {
    isLoading: !isSuggestedFiltersLoaded,
    items,
    show2RowSuggestedFilters: isInSuggestedFilters2RowExperiment,
    showCounts: !isInSuggestedFilterCountsExperiment,
    showSuggestedFilters
  };
}
